import { useCallback, useEffect, useState } from "react";
import { Loader } from "components/UI/Loader";
import { toast } from "react-hot-toast";
import { ReactComponent as RgLogo } from "components/icons/RGLogo.svg";
import { ReactComponent as CloseIcon } from "components/icons/cross-black.svg";
import { clsx } from "clsx";
import { FILE_TYPE_REGEX, IMAGE_TYPE_MESSAGE } from "./constants";
import "./ImageUploader.scss";

interface IImageUploaderProps {
  preview?: string;
  isError: boolean;
  loading: boolean;
  title: string;
  onFileUpload: (file: File) => void;
}

export const ImageUploader: React.FC<IImageUploaderProps> = (props) => {
  const { preview, isError, title, loading, onFileUpload } = props;
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  useEffect(() => {
    if (isError) {
      setPreviewImage(null);
    }
  }, [isError]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      if (!FILE_TYPE_REGEX.test(file.type)) {
        toast.error(IMAGE_TYPE_MESSAGE);
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
        onFileUpload(file);
      };
      reader.readAsDataURL(file);
    }
  }, [onFileUpload]);

  return (
    <div className="ImageUploader">
      <label htmlFor="image-input" className="ImageUploader-Label">
        <div className="ImageUploader-Preview">
          {!preview && !previewImage ? <RgLogo /> : (
            <div
              className={clsx(
                "ImageUploader-PreviewImage",
                loading && "ImageUploader-PreviewImage_isLoad"
              )}
              data-testid="preview"
            >
              <img src={previewImage || preview} alt="user file" />
              <span><CloseIcon /></span>
              <div className="Loader"><Loader /></div>
            </div>
          )}
        </div>
        <p className="ImageUploader-Title">{title}</p>
      </label>
      <input
        type="file"
        id="image-input"
        data-testid="image-input"
        onChange={handleChange}
        accept="image/png, image/jpeg"
        className="ImageUploader-Input"
      />
    </div>
  );
};
